/**
 * Cola de ventas offline (Fase 2).
 *
 * Cuando no hay red, la venta (solo con medio de pago OFFLINE: efectivo /
 * transferencia / cheque) se guarda aquí con una CLAVE DE IDEMPOTENCIA estable.
 * Al reconectar se re-postea a `pos/sale`: el backend, si ya la registró con esa
 * clave, devuelve la venta existente (no duplica). El comprobante SRI se emite en
 * ese momento (diferido). Fail-soft ante fallos de storage.
 *
 * OJO fiscal: una venta offline NO está registrada ni facturada hasta sincronizar.
 * El cajero ya cobró el efectivo; la factura sale al reconectar.
 */

const KEY = 'pos_sale_queue'

const read = () => {
  try {
    const raw = localStorage.getItem(KEY)
    const list = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? list : []
  } catch (e) {
    return []
  }
}

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list))
  } catch (e) {
    // Sin storage: la venta offline no se puede encolar (se informa arriba).
  }
}

const uuid = () => {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  } catch (e) {
    // sigue al fallback
  }
  return 'off-' + Date.now() + '-' + Math.floor(Math.random() * 1e9)
}

export const queueSize = () => read().length

export const peekQueue = () => read()

/** Ventas encoladas que fallaron al sincronizar por un error de negocio (no red). */
export const conflicts = () => read().filter((item) => !!item.conflict)

/** Marca (o limpia) el conflicto de un item tras un intento de sync fallido. */
export const setConflict = (id, message) => {
  write(read().map((item) => (item.id === id ? { ...item, conflict: message || null } : item)))
}

/**
 * Encola una venta con su clave de idempotencia (la misma en cada reintento).
 * Devuelve la clave o null si no se pudo guardar.
 */
export const enqueueSale = (payload) => {
  const key = uuid()
  const list = read()
  list.push({ id: key, at: Date.now(), payload: { ...payload, idempotency_key: key } })
  write(list)
  return key
}

export const removeFromQueue = (id) => write(read().filter((item) => item.id !== id))
